
/**
 * Get full image URL with API base path
 * @param {string} image - Image path or URL
 * @returns {string} Full image URL
 */
export const getImageUrl = (image) => {
    if (!image) return "https://placehold.co/600x600?text=No+Image";
    if (/^https?:\/\//i.test(image) || image.startsWith("blob:")) return image;

    const base = (process.env.VUE_APP_API_URL || "").replace(/\/+$/, "");
    const cleanPath = image.startsWith("/") ? image : "/" + image;
    return `${base}${cleanPath}`;
};

/**
 * Get main product image from product object
 * @param {Object} product - Product object
 * @returns {string} Full image URL
 */
export const getProductImage = (product) => {

    if (!product) return getImageUrl(null);

    if (product.image && typeof product.image === 'string') {
        return getImageUrl(product.image);
    }

    if (Array.isArray(product.images) && product.images.length > 0) {
        const main = product.images.find(img => img.isMain) || product.images[0];
        if (main) {
            return getImageUrl(main.pathImage || main.image);
        }
    }

    return getImageUrl(product.image);
};
